export const isNotNullOrEmpty = (value) => {
  if (value == null) return false; // catches null and undefined

  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  // For other types (e.g. numbers, booleans), treat as not empty
  return true;
};

export const convertJsonTextToHtml = (text) => {
  let result = text ?? "";
  result = result.replaceAll("\\n", "<br/>");
  result = result.replaceAll("\\b", "<strong>");
  result = result.replaceAll("//b", "</strong>");
  result = result.replaceAll("\\hr", "<hr>");

  return result;
};

// Simple markdown parser function to replace the external marked library
export const parseMarkdown = (text) => {
  if (!text) return "";

  // Parse headers
  text = text.replace(/## (.*?)$/gm, "<h2>$1</h2>");

  // Parse bold text
  text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  // Parse italic text
  text = text.replace(/\*(.*?)\*/g, "<em>$1</em>");

  // Parse links
  text = text.replace(
    /\[(.*?)\]\((.*?)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  // Parse unordered lists (consecutive "*"/"-" lines share one <ul>)
  text = text.replace(/^[*-] .*(?:\n[*-] .*)*/gm, (block) =>
    "<ul>" + block.replace(/^[*-] (.*)$/gm, "<li>$1</li>") + "</ul>"
  );

  // Parse ordered lists (consecutive "N." lines share one <ol>)
  text = text.replace(/^\d+\. .*(?:\n\d+\. .*)*/gm, (block) =>
    "<ol>" + block.replace(/^\d+\. (.*)$/gm, "<li>$1</li>") + "</ol>"
  );

  // Parse line breaks
  text = text.replace(/\n\n/g, "<br /><br />");

  return text;
};
